import React from 'react';
import Icon from '@ant-design/icons';

import { ReactComponent as AccountSettings } from '../../../assets/icons/svg/Account-Settings.svg';
import { ReactComponent as ArrowLeftDouble } from '../../../assets/icons/svg/Arrow-Left-Double.svg';
import { ReactComponent as ArrowLeft } from '../../../assets/icons/svg/Arrow-Left.svg';
import { ReactComponent as ArrowRightDouble } from '../../../assets/icons/svg/Arrow-Right-Double.svg';
import { ReactComponent as ArrowRight } from '../../../assets/icons/svg/Arrow-Right.svg';
import { ReactComponent as ArrowUp } from '../../../assets/icons/svg/Arrow-Up.svg';
import { ReactComponent as Billing } from '../../../assets/icons/svg/Billing.svg';
import { ReactComponent as ChartLoading } from '../../../assets/icons/svg/Chart-Loading.svg';
import { ReactComponent as CheckCircle } from '../../../assets/icons/svg/Check-Circle.svg';
import { ReactComponent as Check } from '../../../assets/icons/svg/Check.svg';
import { ReactComponent as CloseX } from '../../../assets/icons/svg/Close-X.svg';
import { ReactComponent as DeleteTrash } from '../../../assets/icons/svg/Delete-Trash.svg';
import { ReactComponent as Download } from '../../../assets/icons/svg/Download.svg';
import { ReactComponent as Edit } from '../../../assets/icons/svg/Edit.svg';
import { ReactComponent as ErrorAlert } from '../../../assets/icons/svg/Error-Alert.svg';
import { ReactComponent as FacebookLogo } from '../../../assets/icons/svg/Facebook-Logo.svg';
import { ReactComponent as GenaLogoDark } from '../../../assets/icons/svg/Gena-Logo-Dark.svg';
import { ReactComponent as History } from '../../../assets/icons/svg/History.svg';
import { ReactComponent as Info } from '../../../assets/icons/svg/Info.svg';
import { ReactComponent as InstagramLogo } from '../../../assets/icons/svg/Instagram-Logo.svg';
import { ReactComponent as LineArrowExpandWindow } from '../../../assets/icons/svg/Line-Arrow-Expand-Window.svg';
import { ReactComponent as LineArrowRight } from '../../../assets/icons/svg/Line-Arrow-Right.svg';
import { ReactComponent as LinkedinLogo } from '../../../assets/icons/svg/Linkedin-Logo.svg';
import { ReactComponent as LockClosed } from '../../../assets/icons/svg/Lock-Closed.svg';
import { ReactComponent as Logout } from '../../../assets/icons/svg/Logout.svg';
import { ReactComponent as Mail } from '../../../assets/icons/svg/Mail.svg';
import { ReactComponent as Menu } from '../../../assets/icons/svg/Menu.svg';
import { ReactComponent as OpenFolder } from '../../../assets/icons/svg/Open-Folder.svg';
import { ReactComponent as Reset } from '../../../assets/icons/svg/Reset.svg';
import { ReactComponent as Retry } from '../../../assets/icons/svg/Retry.svg';
import { ReactComponent as Search } from '../../../assets/icons/svg/Search.svg';
import { ReactComponent as Settings } from '../../../assets/icons/svg/Settings.svg';
import { ReactComponent as Switch } from '../../../assets/icons/svg/Switch.svg';
import { ReactComponent as Undo } from '../../../assets/icons/svg/Undo.svg';
import { ReactComponent as UserAddPlus } from '../../../assets/icons/svg/User-Add-Plus.svg';
import { ReactComponent as UserCircleSingle } from '../../../assets/icons/svg/User-Circle-Single.svg';
import { ReactComponent as UserStory } from '../../../assets/icons/svg/User-Story.svg';
import { ReactComponent as HidePass } from '../../../assets/icons/svg/hide-pass.svg';
import { ReactComponent as ShowPass } from '../../../assets/icons/svg/show-pass.svg';
const iconMap = {
  AccountSettings,
  ArrowLeftDouble,
  ArrowLeft,
  ArrowRightDouble,
  ArrowRight,
  ArrowUp,
  Billing,
  ChartLoading,
  CheckCircle,
  Check,
  CloseX,
  DeleteTrash,
  Download,
  Edit,
  ErrorAlert,
  FacebookLogo,
  GenaLogoDark,
  History,
  Info,
  InstagramLogo,
  LineArrowExpandWindow,
  LineArrowRight,
  LinkedinLogo,
  LockClosed,
  Logout,
  Mail,
  Menu,
  OpenFolder,
  Reset,
  Retry,
  Search,
  Settings,
  Switch,
  Undo,
  UserAddPlus,
  UserCircleSingle,
  UserStory,
  HidePass,
  ShowPass
}

const CustomIcon = ({ name, width = 24, height = 24, color, ...rest }) => {
  const SvgIcon = iconMap[name];
  return SvgIcon ? <Icon
    component={SvgIcon}
    style={{
      fontSize: width || height || '1em',
      color: color || 'inherit',
    }}
    {...rest}
  /> : null;
};

export default CustomIcon;
